module.exports = __webpack_public_path__ + "static/media/girl-8.36b4cc35.svg";